import { render } from "./TableEmpty.vue?vue&type=template&id=03a0d85c&scoped=true"
const script = {}

import "./TableEmpty.vue?vue&type=style&index=0&id=03a0d85c&scoped=true&lang=scss"

import exportComponent from "/builds/gh_prod_devops/gh_prod_devops_web/webtrade_prod_deploy/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-03a0d85c"]])

export default __exports__